import Chat from "features/Chat/Chat";

const ChatPage: React.FC = () => {
  return <Chat />;
};

export default ChatPage;
